<template>
  <div>
    <b-navbar sticky toggleable="lg" type="dark" class="mb-4 pb-0">
      <div class="col-lg-8 col-md-10 col-sm-12 col-xs-12 mx-auto mb-4">
        <b-navbar-brand
          left
          to="#"
          tag="h4"
          class="col-xs-12 col-sm-7 col-md-5 col-lg-5 pl-0 ml-0"
        >
          <LogoPublic />
        </b-navbar-brand>
      </div>
    </b-navbar>
    <b-alert :show="saveerror == 1" variant="danger">
      <b
        >Your answers could not be saved, please contact GDQ Associates for
        assistance</b
      >
    </b-alert>
    <!--
      Introduction text
    -->
    <div
      v-if="question_sequence == -1"
      class="col-lg-6 col-md-8 col-sm-10 col-xs-12 mx-auto gdqquestion"
    >
      <span v-html="addonsurvey && addonsurvey.survey_introduction" />
    </div>
    <!--
      Progress bar
    -->
    <div
      v-show="question_sequence > -1 && !showtext && !alldone"
      class="col-lg-8 col-md-10 col-sm-12 col-xs-12 mx-auto mt-4"
    >
      <b-progress
        variant="secondary"
        height="2rem"
        :max="questions.length"
        align-v="center"
      >
        <b-progress-bar align-v="center" :value="question_sequence" />
        <div
          align-v="center"
          style="z-index: 1;position: absolute;left:16px;border"
          class="col-12 px-4 pt-3 text-center"
        >
          <font color="black">
            {{ question_sequence + 1 }} / {{ questions.length }}
          </font>
        </div>
      </b-progress>
    </div>
    <!--
      Question section
    -->
    <div
      v-if="showquestionsection"
      class="col-lg-6 col-md-8 col-sm-10 col-xs-12 mx-auto gdqquestion"
    >
      <h3 class="my-4 py-4">
        <span
          v-show="!questions[question_sequence].question_is_control"
          v-html="`${questions[question_sequence].question_text}`"
        >
        </span>
      </h3>
      <!-- Question type 1 - Vertical Radio Buttons -->
      <div
        v-show="questions[question_sequence].question_questiontype_id == 1"
        class="ml-0 pl-0"
      >
        <b-button-group
          vertical
          class="btn-group btn-group-vertical btn-group-toggle col-lg-8 col-md-8 col-sm-12 col-xs-12 ml-0 pl-0"
        >
          <label
            v-for="option in questions[question_sequence].options"
            :id="'o' + option.option_id"
            :key="option.option_id"
            class="btn btn-questionnaire my-2 text-left ml-0"
            :class="
              (answers[question_sequence] != null &&
                answers[question_sequence] === option.value) ||
              (currentoption === option.option_id &&
                !questions[question_sequence].question_is_control)
                ? 'btn-primary'
                : 'btn-outline-primary'
            "
            :disabled="settinganswer"
            @click.prevent="
              currentoption = option.option_id;
              setanswer(
                question_sequence,
                option.value,
                questions[question_sequence].question_id
              );
            "
          >
            <span
              v-if="
                answers[question_sequence] != null &&
                answers[question_sequence] === option.value
              "
              class="mr-2"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 512 512"
                focusable="false"
                class="white fa-icon"
              >
                <path
                  d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0l112.1 112.1 240.1-240.1c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z"
                />
              </svg>
            </span>
            <span
              v-if="
                answers[question_sequence] != null &&
                answers[question_sequence] !== option.value
              "
              class="w-10 mr-2"
            >
              &nbsp;&nbsp;&nbsp;
            </span>
            <input
              type="radio"
              autocomplete="off"
              class="text-left"
              :checked="
                answers[question_sequence] != null &&
                answers[question_sequence] === option.value
              "
            />{{ option.text }}
          </label>
        </b-button-group>
      </div>
      <!-- Question type 2 - Textbox -->
      <div
        v-show="questions[question_sequence].question_questiontype_id == 2"
        class="row px-3"
      >
        <b-input-group>
          <b-form-input
            v-if="questions[question_sequence].only_digits == 0"
            v-model="answers[question_sequence]"
            class="col-12"
            @keyup.enter.native="
              answers[question_sequence] != '' ? nextpage(300) : false
            "
          />
          <b-form-input
            v-if="questions[question_sequence].only_digits == 1"
            v-model="answers[question_sequence]"
            class="col-12"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
            @keyup.enter.native="
              answers[question_sequence] != '' ? nextpage(300) : false
            "
          />
          <b-input-group-append>
            <b-button
              variant="primary"
              :disabled="
                !answers[question_sequence] ||
                answers[question_sequence] == '' ||
                settinganswer
              "
              class="btn-small btn-questionnaire pb-1 pt-1"
              @click.prevent="nextpage(300)"
            >
              <span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 512 512"
                  focusable="false"
                  class="white fa-icon"
                >
                  <path
                    d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0l112.1 112.1 240.1-240.1c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z"
                  />
                </svg>
              </span>
              OK
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
      <!-- Question type 3 - Textarea -->
      <div v-show="questions[question_sequence].question_questiontype_id == 3">
        <b-form-textarea
          v-model="answers[question_sequence]"
          :maxlength="
            questions[question_sequence].text_maxlength != 0
              ? questions[question_sequence].text_maxlength
              : 100
          "
          class="col-12"
        />
        <div class="col-12 text-right">
          {{ text_27 }}:
          {{
            questions[question_sequence].text_maxlength != 0
              ? questions[question_sequence].text_maxlength
              : 100 -
                (answers[question_sequence]
                  ? answers[question_sequence].length
                  : 0)
          }}
        </div>
      </div>
      <!-- Question type 4 - Horizontal radio buttons -->
      <div
        v-show="questions[question_sequence].question_questiontype_id == '4'"
        class="row"
      >
        <b-button-group
          horizontal
          class="btn-group btn-group-horizontal btn-group-toggle col text-center"
        >
          <label
            v-for="option in questions[question_sequence].options"
            :id="'o' + option.option_id"
            :key="option.option_id"
            class="btn btn-questionnaire btn-questionnaire-horizontal btn-iphone text-center py-4"
            :class="
              (answers[question_sequence] != null &&
                answers[question_sequence] === option.value) ||
              currentoption === option.option_id
                ? 'btn-primary'
                : 'btn-outline-primary'
            "
            :disabled="settinganswer"
            @click.prevent="
              currentoption = option.option_id;
              setanswer(
                question_sequence,
                option.value,
                questions[question_sequence].question_id
              );
            "
          >
            <span
              v-if="
                answers[question_sequence] &&
                answers[question_sequence] == option.value
              "
              class="mr-2"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 512 512"
                focusable="false"
                class="white fa-icon"
              >
                <path
                  d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0l112.1 112.1 240.1-240.1c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z"
                />
              </svg>
            </span>
            <input type="radio" class="text-center" />{{ option.text }}
          </label>
        </b-button-group>
      </div>
      <div
        v-show="questions[question_sequence].question_questiontype_id == '4'"
        class="row"
      >
        <div class="col-6 text-primary">
          {{
            questions[question_sequence].question_minimum_hint
              ? questions[question_sequence].question_minimum_hint
              : text_25
          }}
        </div>
        <div class="col-6 text-right text-primary">
          {{
            questions[question_sequence].question_maximum_hint
              ? questions[question_sequence].question_maximum_hint
              : text_25
          }}
        </div>
      </div>
    </div>
    <!--
      Finished text
    -->
    <div class="my-4 py-4">&nbsp;</div>
    <!--
      Thank you text
    -->
    <div
      v-show="alldone && !saveerror"
      class="col-lg-8 col-md-10 col-sm-12 col-xs-12 h4 py-4 my-4 mx-auto text-center"
    >
      <h4>
        {{ text_28 }}
      </h4>
      {{ text_20 }}
    </div>
    <!--
      Navigation
    -->
    <div
      v-show="!alldone"
      class="row col-lg-8 col-md-8 col-sm-12 col-xs-12 mx-auto py-4 my-4"
    >
      <div class="col-6 pl-0">
        <b-button
          v-show="question_sequence > 0"
          class="align-right"
          variant="secondary"
          @click.prevent="prevpage"
        >
          &lt; {{ text_1 }}
        </b-button>
      </div>
      <div class="col-6 text-right pr-0">
        <b-button
          v-show="
            showtext ||
            (question_sequence > -1 &&
              questions[question_sequence].question_type == 3) ||
            answers[question_sequence]
          "
          class="align-right"
          variant="primary"
          :disabled="settinganswer"
          @click.prevent="nextpage(300)"
        >
          {{ text_2 }}
        </b-button>
        <b-button
          v-show="question_sequence == -1"
          class="align-right"
          variant="primary"
          :disabled="settinganswer"
          @click.prevent="nextpage(300)"
        >
          {{ text_2 }}
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>
import LogoPublic from './LogoPublic.vue'
import { config } from '@/../config'

const sleep = (milliseconds) => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds))
}

export default {
  name: 'AddOnSurvey',
  components: {
    LogoPublic
  },
  data () {
    return {
      language_id: 154,
      showtext: false,
      alldone: false,
      saveerror: 0,
      addonsurvey_id: this.$route.params.a ? this.$route.params.a : '',
      surveymember_id: this.$route.params.m ? this.$route.params.m : '',
      addonsurvey: null,
      questions: [],
      answers: [],
      currentoption: 0,
      settinganswer: false,
      question_sequence: -1,
      text_1: '',
      text_2: '',
      text_3: '',
      text_4: '',
      text_5: '',
      text_6: '',
      text_7: '',
      text_8: '',
      text_9: '',
      text_10: '',
      text_11: '',
      text_12: '',
      text_13: '',
      text_14: '',
      text_15: '',
      text_16: '',
      text_17: '',
      text_18: '',
      text_19: '',
      text_20: '',
      text_21: '',
      text_22: '',
      text_23: '',
      text_24: '',
      text_25: '',
      text_26: '',
      text_27: '',
      text_28: '',
      text_29: '',
      text_30: '',
      text_31: '',
      text_32: '',
      text_33: '',
      text_34: '',
      text_35: '',
      text_36: '',
      text_37: '',
      text_38: '',
      text_39: ''
    }
  },
  computed: {
    showquestionsection: function () {
      if (
        this.question_sequence > -1 &&
        this.question_sequence < this.questions.length &&
        !this.showtext &&
        !this.alldone
      ) {
        return true
      }
      return false
    }
  },
  created () {
    this.survey_get()
  },
  methods: {
    survey_get () {
      this.$store
        .dispatch('record_read', {
          table_name: 'g_addon_surveys',
          id: this.addonsurvey_id
        })
        .then((resp) => {
          // console.log(resp.data)
          this.addonsurvey = resp.data
          this.questions_get()
          this.questionnairetexts_get()
        })
    },
    questions_get () {
      const filter = {
        survey_id: {
          operator: '=',
          value: this.addonsurvey_id
        }
      }
      this.$store
        .dispatch('records_readall', {
          table_name: 'g_addon_questions',
          filter
        })
        .then((resp) => {
          let questions = resp.data.result
          let optionid = 0
          for (let i = 0; i < questions.length; i++) {
            const qstart = parseInt(questions[i].question_minimum_value) || 0
            const qend = parseInt(questions[i].question_maximum_value) || 0
            let options = new Array()
            for (let j = qstart; j <= qend; j++) {
              const option = {
                option_id: j,
                value: j,
                text: j
              }
              optionid++
              options.push(option)
            }
            questions[i].options = options
          }
          this.questions = questions
        })
    },
    questionnairetexts_get () {
      this.$store
        .dispatch('questionnairetexts_fetch', { language_id: this.language_id })
        .then((resp) => {
          var maillink = '<a href="mailto: gdq@gdq.se</a>'
          this.text_1 = resp.data[1] ? resp.data[1] : 'Back'
          this.text_2 = resp.data[2] ? resp.data[2] : 'Next'
          this.text_3 = resp.data[3] ? resp.data[3] : 'Submit'
          this.text_4 = resp.data[4] ? resp.data[4] : 'Go to the GDQ survey'
          this.text_5 = resp.data[5]
            ? resp.data[5]
            : 'Some questions require a response - please answer any questions highlighted in red'
          this.text_6 = resp.data[6] ? resp.data[6] : ''
          this.text_7 = resp.data[7] ? resp.data[7] : 'Invalid code'
          this.text_8 = resp.data[8] ? resp.data[8] : 'Welcome'
          // Consultant name with mailto link
          this.text_9 = resp.data[9]
            ? resp.data[9].replace('[consultant_name]', maillink)
            : 'You have received an invitation to complete this questionnaire because XX XX considers it to be a valuable tool for finding out more about your work group in order to help you and your colleagues gain a deeper understanding of how you work together as a group, and what can be done to help your work group work better.'
          this.text_10 = resp.data[10]
            ? resp.data[10]
            : 'Please enter your personal code to launch the questionnaire.'
          this.text_11 = resp.data[11]
            ? resp.data[11]
            : 'Enter your code here.'
          this.text_12 = resp.data[12]
            ? resp.data[12]
            : '...And please confirm that we have your consent to store your responses and personal details:'
          // Privacy policy
          const link =
            '<a href="' + config.links.privacyPolicy + '" target="_new">'
          this.text_13 = resp.data[13]
            ? resp.data[13]
            : "Yes, I give my consent to GDQ Associates to process my personal data for the reasons set out above in accordance with the company's privacy policy. If you would like further information about how we process your personal data and your rights in this regard, click here."
          this.text_13 = this.text_13.replace('[link]', link)
          this.text_13 = this.text_13.replace('[/link]', '</a>')
          // Consent research
          this.text_14 = resp.data[14]
            ? resp.data[14]
            : 'I give my consent to my responses to this questionnaire being used anonymously without any identifying markers for the purposes of test development, standardisation and research.'
          let textno = 15
          this.text_15 = resp.data[textno]
            ? resp.data[textno]
            : 'All rights related to this questionnaire and the associated testing procedure and consultancy processes are the property of GDQ Associates AB. The Group Development Questionnaire (GDQ) is protected by copyright laws. Duplicating, printing or otherwise copying the contents of this questionnaire, in whole or in part, is thus prohibited without the permission of the copyright holder. It is prohibited for anyone other than a certified GDQ consultant to use this questionnaire.'
          this.text_16 = resp.data[16]
            ? resp.data[16]
            : 'Questionnaire already submitted'
          // Already completed
          this.text_17 = resp.data[17]
            ? resp.data[17].replace('[consultant_name]', maillink)
            : ''
          this.text_18 = resp.data[18]
            ? resp.data[18]
            : 'Please answer all questions marked with red color'
          this.text_19 = resp.data[19] ? resp.data[19] : ''
          this.text_20 = resp.data[20] ? resp.data[20] : 'Thank you!'
          this.text_21 = resp.data[21]
            ? resp.data[21]
            : 'Group Information and Personal Information'
          this.text_22 = resp.data[22] ? resp.data[22] : 'GDQ Questions'
          this.text_23 = resp.data[23]
            ? resp.data[23]
            : 'Please read each statement below. Choose the number that most accurately describes this group at the present time. Use the following key to respond to each statement.<br><br>1 = never true of this group<br>2 = rarely true of this group<br>3 = sometimes true of this group<br>4 = frequently true of this group<br>5 = always true of this group<br><br>Sample question: This group spends considerable time working on important issues.<br><br>If this is never true of this group, mark the number “1” in the box provided for this sample item. If working on important issues is a rare occurrence, mark the number “2” in the box. If working on important issues occurs to some extent, mark the number “3” in the box. If work of this type is frequent, mark the number “4” in the box. If the group, in your opinion, is always working on important issues, mark the number “5” in the box.<br><br>Using the same procedure respond to each of the following statements.'
          this.text_24 = resp.data[24] ? resp.data[24] : 'Free text response'
          this.text_25 = resp.data[25] ? resp.data[25] : 'Never true'
          this.text_26 = resp.data[26] ? resp.data[26] : 'Always true'
          this.text_27 = resp.data[27]
            ? resp.data[27]
            : 'Number of characters remaining '
          this.text_28 = resp.data[28] ? resp.data[28] : 'Thank you!'
          this.text_29 = resp.data[29]
            ? resp.data[29].replace('[consultant_name]', maillink)
            : 'Du har fått en inbjudan till denna enkät  [consultant_name] ser den som ett värdefullt verktyg för att ta reda på din och din grupps upplevelse av organisatoriska frågor. Syftet är att hjälpa dig och dina kollegor få insikt i hur ni upplever det organisatoriska stödet och uppmärksamma inom vilka områden fokus för utveckling bör riktas.'
          this.text_30 = resp.data[30]
            ? resp.data[30]
            : 'Please read each statement below. Choose the number that most accurately describes this group at the present time. Use the following key to respond to each statement.<br><br>1 = never true of this group<br>2 = rarely true of this group<br>3 = sometimes true of this group<br>4 = frequently true of this group<br>5 = always true of this group<br><br>Sample question: This group spends considerable time working on important issues.<br><br>If this is never true of this group, mark the number “1” in the box provided for this sample item. If working on important issues is a rare occurrence, mark the number “2” in the box. If working on important issues occurs to some extent, mark the number “3” in the box. If work of this type is frequent, mark the number “4” in the box. If the group, in your opinion, is always working on important issues, mark the number “5” in the box.<br><br>Using the same procedure respond to each of the following statements.'
          this.text_31 = resp.data[31] ? resp.data[31] : 'OSC Questions'
          this.text_37 = resp.data[37]
            ? resp.data[37]
            : '* = mandatory question'
          this.text_38 = resp.data[38] ? resp.data[38] : 'of'
          this.text_39 = resp.data[39]
            ? resp.data[39]
            : "Your free text responses will be included in the GDQ report alongside other people's free text responses."
        })
    },
    async setanswer (id, answer, question_id) {
      if (this.settinganswer) {
        return false
      }
      this.settinganswer = true
      this.answers[id] = answer
      await this.nextpage(300).then(() => {
        this.settinganswer = false
        this.currentoption = 0
      })
    },
    nextpage: async function (millisecs) {
      await sleep(millisecs).then(() => {
        var _this = this
        if (this.question_sequence == this.questions.length - 1) {
          this.alldone = true
          this.saveanswers(
            this.groupsurveymember_id,
            this.questions,
            this.answers
          )
          // .then((resp) => {
          //   if (!resp.data.result || resp.data.result != "OK") {
          //     this.saveerror = 1;
          //     this.saving = false;
          //   }
          // })
          return false
        }
        if (_this.showtext) {
          _this.showtext = false
          if (_this.question_sequence > -1) {
            return
          }
        }
        _this.question_sequence++
      })
    },
    prevpage: function () {
      if (this.question_sequence === -1) {
        this.showtext = true
        return true
      }
      if (this.showtext) {
        this.showtext = false
      }
      this.question_sequence--
    },
    saveanswers: function (groupsurveymember_id, questions, answers) {
      this.saving = true
      var saveanswers = []
      var question_sequence = 0
      questions.forEach(function (item, index) {
        const newanswer = {
          question_id: item.id,
          question_number: item.question_number,
          answer: answers[question_sequence]
        }
        saveanswers.push(newanswer)
        question_sequence++
      })
      var data = {
        addonsurvey_id: this.addonsurvey_id,
        surveymember_id: this.surveymember_id,
        answers: saveanswers
      }
      return this.$store
        .dispatch('gdq_addonsurvey_saveanswers', data)
        .then((resp) => {
          return resp
        })
    }
  }
}
</script>
<style scoped></style>
